<template>
    <div class="create-user-wrapper">
        <div v-if="!this.isEdit" class="title">Δημιουργία Χρήστη</div>
        <div v-else class="title-edit">
            <v-btn color="red" class="white--text mb-3" @click="blockDialog = true"> Block Χρηστη </v-btn>
            <v-dialog
                v-model="blockDialog"
                width="500"
            >
                <v-card>
                    <v-card-title class="text-h6">
                        Σίγουρα θέλετε να μπλοκάρετε τον χρήστη;
                    </v-card-title>
                    <v-divider />
                    <v-card-actions class="card-actions">
                        <v-btn
                            class="white--text"
                            color="green"
                            @click="blockUser"
                        >
                            Ναι
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="red"
                            @click="blockDialog = false"
                        >
                            ΟΧΙ
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <span>Επεξεργασία Χρήστη</span>
        </div>
        <v-form
            class="user-form"
            style="padding-top: 5vh"
            @keyup.enter="enterKeySubmit"
        >
            <v-text-field
                v-model="user.username"
                label="Login Username"
                class="form-field"
                required
                :rules="rules"
            />
            <v-text-field
                v-model="user.password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                label="Κωδικός"
                value=""
                class="input-group--focused form-field"
                :rules="passRules"
                @click:append="show = !show"
            />
            <v-text-field
                v-model="repeatPassword"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                label="Επαναλάβετε τον κωδικό"
                value=""
                class="input-group--focused form-field"
                :rules="passRules"
                @click:append="show = !show"
            />
            <v-text-field
                v-model="user.firstname"
                label="Όνομα Χρήστη"
                class="form-field"
                :rules="rules"
                required
            />
            <v-text-field
                v-model="user.lastname"
                label="Επώνυμο Χρήστη"
                class="form-field"
                :rules="rules"
                required
            />
            <v-select
                v-model="user.role"
                :items="availableRoles"
                label="Επιλογή Ρόλου"
                class="form-field"
                item-text="role"
                return-object
                :rules="rules"
                prepend-icon="mdi-account"
            >
                <template v-slot:item="{ item }">
                    <v-chip class="white--text" pill :color="getRoleColor(item.role)">{{ getRoleText(item.role) }}</v-chip>
                </template>
                <template v-slot:selection="{ item }">
                    <v-chip class="white--text" pill :color="getRoleColor(item.role)">{{ getRoleText(item.role) }}</v-chip>
                </template>
            </v-select>
            <div class="contractor-selection">
                <span>Επιλογή Εργολάβου</span>
                <v-select
                    v-model="selectedClient"
                    :items="clients"
                    return-object
                    item-text="name"
                    label="Πελάτης"
                    outlined
                    class="contractor-form-field"
                    :disabled="userAsAdmin"
                ></v-select>
                <v-select
                    v-model="user.contractor"
                    :items="contractors"
                    return-object
                    item-text="name"
                    label="Εργολάβος"
                    outlined
                    :disabled="!selectedClient || userAsAdmin"
                    class="contractor-form-field"
                ></v-select>
            </div>
            <div
                class="submit-button-wrapper"
            >
                <v-btn
                    class="white--text"
                    color="black"
                    :disabled="shouldDisableSubmit"
                    :loading="loading"
                    @click="submit"
                >
                    <span v-if="!this.isEdit">
                        Δημιουργια
                    </span>
                    <span v-else>
                        Υποβολη
                    </span>
                </v-btn>
            </div>
            <alert :show-alert="showAlert" :message="message" :type="type" />
        </v-form>
    </div>
</template>
<script>
    import user from '@/services/user'
    import userMixin from '@/mixins/user'
    import Alert from '@/components/Alert'
    import client from '@/services/client'

    export default {
        components: { Alert },
        mixins: [ userMixin ],
        computed: {
            userAsAdmin() {
                return this.user?.role?.role === 'ROLE_ADMIN'
            },
            shouldDisableSubmit() {
                return !(this.user.username && this.user.password && this.user.firstname && this.user.lastname && this.user.role && ((this.user.contractor && !this.userAsAdmin) || this.userAsAdmin) && this.repeatPassword)
            },
            isEdit() {
                if (this.$route.params?.userId) {
                    return true
                }
                return false
            }
        },
        watch: {
            'user.role'(newVal, oldVal) {
                if (newVal?.role === 'ROLE_ADMIN') {
                    user.contractor = null
                }
            }
        },
        data() {
            return {
                user: {
                    username: null,
                    password: null,
                    firstname: null,
                    lastname: null,
                    role: null,
                    contractor: null
                },
                repeatPassword: null,
                loading: false,
                show: false,
                availableRoles: [],
                clients: [],
                contractors: [],
                message: null,
                type: null,
                showAlert: false,
                selectedClient: null,
                blockDialog: false,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                passRules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό',
                    v => !!(v?.length > 4) || 'Ο κωδικός πρέπει να είναι μεγαλύτερος από 4 χαρακτήρες'
                ]
            }
        },
        created() {
            this.getAvailableUserRoles()
            this.getAllClients()
            if (this.isEdit) {
                user.getUserById(this.$route.params.userId).then(resp => {
                    this.initUser(resp.data)
                })
            }
        },
        methods: {
            blockUser() {
                if (this.isEdit) {
                    this.blockDialog = false
                    user.banUser(this.$route.params.userId).then(resp => this.setAlert('Ο χρήστης μπλοκαρίστηκε με επιτυχία', 'success')).catch((error) => {
                        let message = 'Generic Error'
                        console.log(error)
                        this.setAlert(message, 'error')
                    })
                }
            },
            initUser(user) {
                this.user.username = user.username
                this.user.firstname = user.firstName
                this.user.lastname = user.lastName
                this.user.role = user.roles[0]
                this.user.contractor = user.contractor
                this.repeatPassword = null
                this.user.password = null
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.selectedClient = this.clients[0]
                    }
                    this.clients.forEach(client => { this.contractors = this.contractors.concat(client.contractors) })
                })
            },
            resetForm() {
                this.user = {
                    username: null,
                    password: null,
                    firstname: null,
                    lastname: null,
                    contractor: null,
                    role: null
                }
                this.repeatPassword = null
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            getAvailableUserRoles() {
                user.getAllUserRoles().then((resp) => {
                    this.availableRoles = resp.data
                })
            },
            trimUserFields() {
                this.user.username = this.user.username.trim()
                this.user.password = this.user.password.trim()
                this.user.firstname = this.user.firstname.trim()
                this.user.lastname = this.user.lastname.trim()
            },
            submit() {
                if (!this.isEdit) {
                    this.submitCreate()
                } else {
                    this.submitEdit()
                }
            },
            submitEdit() {
                this.loading = true
                if (this.user.password !== this.repeatPassword) {
                    this.setAlert('Οι κωδικοί δεν είναι ίδιοι', 'error')
                    this.loading = false
                    return
                }
                this.trimUserFields()
                user.updateUser(this.$route.params.userId, this.user).then(resp => {
                    this.loading = false
                    this.setAlert('Ο χρήστης τροποποιήθηκε με επιτυχία', 'success')
                }).catch((error) => {
                    const code = error.response.data.code
                    let message = 'Generic Error'
                    if (code === 'USERNAME_EXISTS') {
                        message = 'Το login username υπάρχει ήδη'
                    } else if (code === 'WRONG_PASSWORD_FORMAT') {
                        message = 'O κωδικός πρέπει να είναι μεγαλύτερος των 4ων χαρακτήρων'
                    } else if (code === 'WRONG_USERNAME_FORMAT') {
                        message = 'Το login username πρέπει να είναι μεγαλύτερο των 4ων χαρακτήρων'
                    } else if (code === 'CONTRACTOR_NOT_FOUND') {
                        message = 'Δεν ανατεθηκε σε Contractor ο χρήστης'
                    }
                    this.setAlert(message, 'error')
                    this.loading = false
                })
            },
            submitCreate() {
                this.loading = true
                if (this.user.password !== this.repeatPassword) {
                    this.setAlert('Οι κωδικοί δεν είναι ίδιοι', 'error')
                    this.loading = false
                    return
                }
                this.trimUserFields()
                user.createUser(this.user).then(resp => {
                    this.loading = false
                    this.setAlert('Ο χρήστης δημιουργήθηκε με επιτυχία', 'success')
                    this.resetForm()
                }).catch((error) => {
                    const code = error.response.data.code
                    let message = 'Generic Error'
                    if (code === 'USERNAME_EXISTS') {
                        message = 'Το login username υπάρχει ήδη'
                    } else if (code === 'WRONG_PASSWORD_FORMAT') {
                        message = 'O κωδικός πρέπει να είναι μεγαλύτερος των 4ων χαρακτήρων'
                    } else if (code === 'WRONG_USERNAME_FORMAT') {
                        message = 'Το login username πρέπει να είναι μεγαλύτερο των 4ων χαρακτήρων'
                    } else if (code === 'CONTRACTOR_NOT_FOUND') {
                        message = 'Δεν ανατεθηκε σε Contractor ο χρήστης'
                    }
                    this.setAlert(message, 'error')
                    this.loading = false
                })
            }
        }
    }
</script>
<style scoped>
    .title-edit {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .title {
        text-align: center;
    }
    .user-form {
        margin-bottom: 5%;
    }
    .contractor-form-field {
        width: 90%;
        min-width: 280px;
    }
    .form-field {
        min-width: 300px;
        max-width: 600px;
        width: 50%;
        margin: 0 auto;
    }
    .submit-button-wrapper {
        margin-top: 1rem;
        display: flex;
        justify-content: center;
    }

    .contractor-selection {
        display: flex;
        min-width: 300px;
        max-width: 600px;
        width: 55%;
        flex-direction: column;
        align-items: center;
        border: solid 1px gray;
        padding: 0.5rem;
        margin: 0 auto;
        border-radius: 5px;
    }
    .card-actions {
        display: flex;
        justify-content: center;
    }
</style>
